import React from 'react';
import { makeStyles, Container, Typography, Grid, Dialog, Button } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { DialogTitle, globalDialogStyle, messageBoxDialogStyle, DialogContent } from "../../../UIComponent/CommonStyle"

const useStyles = makeStyles((theme) => ({
    ...globalDialogStyle(theme),
    ...messageBoxDialogStyle(theme),
}));

export default function WarningBox({ handleClose, mode, open }) {
    const classes = useStyles();
    const intl = useIntl();

    return (
        <Container className={classes.container} variant="outlined">
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {intl.formatMessage({ id: 'new_application.waring_title' })}
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography>{intl.formatMessage({ id: 'error.sick_entitlement_not_sufficient_warning' })}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.okButton}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={handleClose}
                                >
                                    {intl.formatMessage({ id: 'waring.ok' })}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </Container>
    )
}